import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const KesibukanKegiatan = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const { state } = useLocation();

  useEffect(() => {
    if (state?.user) {
      setProfile(state?.user);
    }
  }, [state?.user]);

  const onHandleSubmit = () => {
    const mergedUser = { ...state.user, ...profile };
    navigate('/app/profile/update/social-media', {
      state: { user: mergedUser },
    });
  };

  return (
    <>
      <div className="py-5 text-center">
        <h2>III. KESIBUKAN DAN KEGIATAN TAMBAHAN</h2>
        <p className="lead">
          Bagian ini merupakan pendataan mengenai aktivitas, kesibukan, serta
          kegiatan tambahan yang sedang dijalani mahasiswa selama periode
          Magang/Praktikum/Volunteer. Data ini penting untuk memahami konteks
          keterlibatan mahasiswa, potensi pengembangan diri, serta peluang
          kontribusi yang bisa disesuaikan dengan waktu dan kapasitas
          masing-masing individu. Isi bagian ini dengan JUJUR dan BENAR!
        </p>
      </div>

      <div className="row g-5">
        <div className="col-md-12 col-lg-8">
          <form className="needs-validation mb-5">
            <div className="row g-3">
              <div className="card">
                <div className="card-body">
                  <div
                    class="alert alert-primary d-flex align-items-center"
                    role="alert"
                  >
                    <div>
                      <p>
                        Pengisian Data tidak diperbolehkan menggunakan emoticon
                        seperti: (🙏🔥👌)
                      </p>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Apakah kamu memiliki kesibukan lain saat ini? Silakan
                        sebutkan dan jelaskan secara singkat. *
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            activitiesOthers: e.target.value,
                          })
                        }
                        value={profile?.activitiesOthers}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Apakah kamu memiliki kesibukan lain saat ini? Silakan
                        sebutkan dan jelaskan secara singkat (diluar kuliah dan
                        magang)
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            activitiesOutsideCollegeAndInternship:
                              e.target.value,
                          })
                        }
                        value={profile?.activitiesOutsideCollegeAndInternship}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Apakah kamu memiliki usaha/bisnis (sosial maupun
                        lainnya)?
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            haveABusiness: e.target.value,
                          })
                        }
                        value={profile?.haveABusiness}
                        rows={2}
                        type="text"
                        className="form-control"
                      />
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Apakah kamu tergabung dalam komunitas sosial lainnya?
                        (sebutkan nama, peran, dan aktivitas)
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            joinedSocialCommunities: e.target.value,
                          })
                        }
                        value={profile?.joinedSocialCommunities}
                        rows={2}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-12">
                      <label htmlFor="country" className="form-label">
                        Apakah rencanamu dalam waku 5 tahun ke depan, dalam
                        aspek karir maupun pendidikan? *
                      </label>
                      <select
                        value={profile?.fiveYearPlan}
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            fiveYearPlan: e.target.value,
                          })
                        }
                        className="form-select"
                        id="country"
                      >
                        <option defaultValue>Pilih</option>
                        <option value="Melanjutkan pendidikan">
                          Melanjutkan pendidikan
                        </option>
                        <option value="Mengembangkan usaha bisnis (maupun bisnis sosial)">
                          Mengembangkan usaha bisnis (maupun bisnis sosial)
                        </option>
                        <option value="Membentuk gerakan atau komunitas sosial">
                          Membentuk gerakan atau komunitas sosial
                        </option>
                        <option value="Lainnya">Lainnya</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label htmlFor="address" className="form-label">
                        Ceritakan secara singkat mengenai rencanamu ke depan
                        sesuai dengan pilihan yang kamu isi pada pertanyaan
                        sebelumnya. *
                      </label>
                      <textarea
                        onChange={(e) =>
                          setProfile({
                            ...profile,
                            fiveYearPlanDescription: e.target.value,
                          })
                        }
                        value={profile?.fiveYearPlanDescription}
                        rows={3}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={() => onHandleSubmit()}
              className="w-100 btn btn-primary btn-lg my-3"
              type="button"
            >
              Lanjut
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default KesibukanKegiatan;
